import { useMemo } from "react"

import { useExternalDimensioningModelsQuery } from "entities/dim-configuration/graphql/external-dimensioning.queries.generated"

/**
 * Hook to check if an external dimensioning model is available for a given product type
 * @param productType - The product type to check for dimensioning availability
 * @returns Object containing availability status and loading state
 */
export function useExternalDimensioningModelAvailability(
  productType: string | null | undefined
) {
  const { data: externalDimensioningModelsData, loading: isLoadingModels } =
    useExternalDimensioningModelsQuery()

  const isExternalDimensioningAvailable = useMemo(() => {
    if (isLoadingModels || !externalDimensioningModelsData) return false
    return (
      externalDimensioningModelsData.externalDimensioningModels?.models?.some(
        model => model?.id === productType
      ) ?? false
    )
  }, [externalDimensioningModelsData, productType, isLoadingModels])

  return {
    isExternalDimensioningAvailable,
    isLoading: isLoadingModels,
    data: externalDimensioningModelsData
  }
}
